
// ProductThumbnail component - renders a product thumbnail image
function ProductThumbnail({ product, size = 128, alt = '' }) {
  // Use CDN URL for product images
  let thumbUrl = product?.id 
    ? `https://renderfarm2.chameleonpower.com/proxy/getImage.ashx?spec=!${product.specifier}&type=prod&extra=(focus=300)&Size=100`
    : null;


    if(product.seriesID == '9761'){
      thumbUrl = `https://renderfarm2.chameleonpower.com/proxy/getImage.ashx?specifier=${product.specifier}&type=base&extra=(focus=(@SIZE/@IMAGE[1][RES][X]))&Size=250&form=png`
    }

  if (!thumbUrl) {
    return <div style={{ width: size, height: size, backgroundColor: '#eee' }} />;
  }

  return (
    <img 
      src={thumbUrl} 
      alt={alt || product?.name || 'Product'} 
      style={{ width: '100%', height: '100%', objectFit: 'cover' }}
      onError={(e) => {
        e.target.style.display = 'none';
      }}
    />
  );
}

export { ProductThumbnail };
